import style from './InstructionsScreen.css';
import useTranslation from '../../../localization/i18n.context';
import Title from '../Typography/Title';
import BodyText from '../Typography/BodyText';
import Button from '../Button/Button';
import TopUpAppBar from '../../Wallet/TopUpAppBar/TopUpAppBar';
import FAWRY_CARD_CODE from '../../../constants/fawry.card.code';

export default function InstructionsScreen({
  image,
  title,
  organizationCode,
  subtitle = null,
  instructions = [],
  cta = null,
}) {
  const { t, getOrganization } = useTranslation();

  return (
    <>
      <TopUpAppBar />

      <div className={style.container}>
        <main className={style.main}>
          <img src={image} width={160} height={160} />
          <div className={style.title}>
            <Title
              text={t(title, {
                '{card name}': getOrganization(organizationCode),
              })}
            />
            {subtitle && (
              <BodyText
                text={t(subtitle, {
                  '{card name}': getOrganization(organizationCode),
                })}
                className={style.subtitle}
              />
            )}
          </div>
          {instructions.length > 0 && (
            <div className={style['ordered-list']}>
              {instructions.map(item => (
                <div className={style.item}>
                  <span className={style.icon}>{item.icon}</span>
                  <span className={style.text}>
                    {t(item.title, {
                      '{card name}': getOrganization(organizationCode),
                      '{fawry code}': FAWRY_CARD_CODE,
                    })}
                  </span>
                </div>
              ))}
            </div>
          )}
        </main>
        {cta && (
          <div className="fixed-cta">
            <Button type={Button.Type.PRIMARY} fullWidth onClick={cta.onClick}>
              {t(cta?.text)}
            </Button>
          </div>
        )}
      </div>
    </>
  );
}
